'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minuteAgo;


// WEBPACK FOOTER //
// ./~/sugar-date/number/minuteAgo.js